/** * 校验正负正数就返回true  **/
function isIntNum(val){
  var regPos = / ^\d+$/; // 非负整数
  var regNeg = /^\-[1-9][0-9]*$/; // 负整数
  if(regPos.test(val) ){
    return true;
  }else{
    return false;
  }
}

export default {
  isIntNum: function (val) {
    return isIntNum(val);
  }
}



// WEBPACK FOOTER //
// ./src/api/string.js